import { Dialog } from "@headlessui/react";
import ModalDivider from "./components/ModalDivider";
import ModalTitle from "./components/ModalTitle";
import BaseModalTransition from "../components/BaseModalTransition";
import clsx from "clsx";
import { noop } from "lodash";

export type Props = {
  isOpen: boolean; // This prop is to allow user to change their preferences
  className?: string;
  children?: React.ReactNode;
};

const CookieModal: React.FC<Props> = ({ className, isOpen, children }) => {
  return (
    //Cannot close modal until preferences are selected, onClose is required
    <BaseModalTransition
      isOpen={isOpen}
      onClose={noop}
      className={clsx("z-cookieBanner bg-gray-950 text-white", className)}
    >
      <div className="fixed inset-0 overflow-y-auto z-modal">
        <div className="laptop:justify-end laptop:p-3 flex min-h-full items-end justify-center text-center">
          <Dialog.Panel
            className={clsx(
              "shadow-xls",
              "bg-gray-900 border-gray-800 text-white rounded-md border p-6 text-left align-middle",
              "laptop:max-w-xl laptop:p-12 laptop:pb-7",
              "flex w-full transform flex-col overflow-hidden  transition-all",
              "dark",
            )}
          >
            <ModalTitle className="mb-5 text-xl font-medium uppercase text-white">
              Your Cookie Settings
            </ModalTitle>
            <ModalDivider />
            {children}
          </Dialog.Panel>
        </div>
      </div>
    </BaseModalTransition>
  );
};
export default CookieModal;
